import { SINGLES } from "@/data/singles";
import { BUNDLES } from "@/data/bundles";
import { OCEAN } from "@/data/ocean";

export const CONSENT_KEY = "gf_consent";
const BRAND = "Grandpa Finn's";
const SKU_FALLBACK = { "fish-oil": "GF-FISHOIL", multi: "GF-MULTI" };

const gtag = (...args) => { if (typeof window.gtag === "function") window.gtag(...args); };
const META_ID = "1592440255515785";
const ADS_SEND_TO = process.env.REACT_APP_GOOGLE_ADS_SEND_TO || "";
const META_EVENTS = { view_item: "ViewContent", add_to_cart: "AddToCart", begin_checkout: "InitiateCheckout" };
let metaOn = false;
let metaPath = null;
const fbq = (...args) => { if (metaOn) window.fbq(...args); };
const metaPageView = () => {
  if (metaPath === window.location.pathname) return;
  metaPath = window.location.pathname;
  fbq("track", "PageView");
};
export const applyMeta = (ads) => {
  if (typeof window.fbq === "function") {
    window.fbq("consent", ads ? "grant" : "revoke");
    metaOn = !!ads;
    return;
  }
  if (!ads) return;
  /* eslint-disable */
  !function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,document,'script','https://connect.facebook.net/en_US/fbevents.js');
  /* eslint-enable */
  window.fbq("init", META_ID);
  metaOn = true;
  metaPageView();
};
export const track = (name, params) => {
  gtag("event", name, params);
  if (!META_EVENTS[name]) return;
  const d = { content_ids: params.items.map((i) => i.item_id), content_type: "product", value: params.value, currency: params.currency };
  if (name === "begin_checkout") d.num_items = params.items.reduce((n, i) => n + i.quantity, 0);
  fbq("track", META_EVENTS[name], d);
};

export const gaItem = (p, quantity = 1, currency) => ({
  item_id: p.sku || (SINGLES[p.id] || BUNDLES[p.id] || OCEAN[p.id] || {}).sku || SKU_FALLBACK[p.id] || p.id,
  item_name: p.short_name || p.name,
  item_brand: BRAND,
  item_category: p.kind || "single",
  price: Number(p.price_usd),
  quantity,
});

export const readConsent = () => {
  try {
    const c = JSON.parse(localStorage.getItem(CONSENT_KEY) || "null");
    return c && Date.now() - c.ts < 365 * 864e5 ? c : null;
  } catch { return null; }
};

const CLARITY_ID = "z6qeiqqyf1";
export const applyClarity = (analytics) => {
  if (typeof window.clarity === "function") return window.clarity("consent", !!analytics);
  if (!analytics) return;
  (function (c, l, a, r, i, t, y) {
    c[a] = c[a] || function () { (c[a].q = c[a].q || []).push(arguments); };
    t = l.createElement(r); t.async = 1; t.src = "https://www.clarity.ms/tag/" + i;
    y = l.getElementsByTagName(r)[0]; y.parentNode.insertBefore(t, y);
  })(window, document, "clarity", "script", CLARITY_ID);
  window.clarity("consent");
};

export const saveConsent = (analytics, ads) => {
  localStorage.setItem(CONSENT_KEY, JSON.stringify({ analytics, ads, ts: Date.now() }));
  applyClarity(analytics);
  applyMeta(ads);
  const a = analytics ? "granted" : "denied";
  const d = ads ? "granted" : "denied";
  gtag("consent", "update", { analytics_storage: a, ad_storage: d, ad_user_data: d, ad_personalization: d });
};

export const pageView = () => {
  gtag("event", "page_view", { page_location: window.location.href, page_path: window.location.pathname, page_title: document.title });
  metaPageView();
};

export const sendPurchaseOnce = (ga) => {
  const key = `gf_purchase_sent_${ga.transaction_id}`;
  if (localStorage.getItem(key)) return false;
  track("purchase", ga);
  fbq("track", "Purchase", { value: ga.value, currency: ga.currency, content_ids: ga.items.map((i) => i.item_id), content_type: "product" }, { eventID: ga.transaction_id });
  if (ADS_SEND_TO) gtag("event", "conversion", { send_to: ADS_SEND_TO, value: ga.value, currency: ga.currency, transaction_id: ga.transaction_id });
  localStorage.setItem(key, "1");
  return true;
};
